module.exports = __webpack_public_path__ + "static/media/Pits.6820a69f.gif";